import PinSetupDialog from "@Components/app/notifications/pin-setup-dialog";
import { Actions, AppContext } from "@Context/common/general/context";
import { AnalyticsEvents } from "@Enums";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useExclusiveMode } from "../shared/use-exclusive-mode";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "PIN_SETUP_REQUIRED";

const PinSetupRequiredNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { dispatch, state } = useContext(AppContext);
  const isExclusiveMode = useExclusiveMode();
  const isPinRequired = state.user.hasPin === false;
  const isActive = isPinRequired && !isExclusiveMode && state.user.authenticated && state.user.hasAllAccessSubscription !== false && Boolean(state.account.id);

  const handleSuccess = useCallback(() => {
    dispatch({
      type: Actions.AppActions.AnalyticsEvent,
      payload: {
        type: AnalyticsEvents.access_pin_created,
      },
    });
  }, [dispatch]);

  const render = useCallback(() => <PinSetupDialog open={isPinRequired} onSuccess={handleSuccess} />, [handleSuccess, isPinRequired]);

  useNotificationCandidate({
    id,
    priority,
    isActive,
    render,
  });

  return null;
};

export const pinSetupRequiredNotification = defineNotificationModule({
  id,
  Resolver: PinSetupRequiredNotificationResolver,
});
